export { DigitalClock } from "./DigitalClock.js";
export { digitalClockClasses, getDigitalClockUtilityClass } from "./digitalClockClasses.js";